"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RightOfWay$ = exports.RightOfWay$outboundSchema = exports.RightOfWay$inboundSchema = void 0;
exports.rightOfWayToJSON = rightOfWayToJSON;
exports.rightOfWayFromJSON = rightOfWayFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const rightofwaydetails_js_1 = require("./rightofwaydetails.js");
/** @internal */
exports.RightOfWay$inboundSchema = z.object({
    has_public_right_of_way: z.boolean(),
    right_of_way_details: z.array(z.nullable(rightofwaydetails_js_1.RightOfWayDetails$inboundSchema)),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "has_public_right_of_way": "hasPublicRightOfWay",
        "right_of_way_details": "rightOfWayDetails",
    });
});
/** @internal */
exports.RightOfWay$outboundSchema = z.object({
    hasPublicRightOfWay: z.boolean(),
    rightOfWayDetails: z.array(z.nullable(rightofwaydetails_js_1.RightOfWayDetails$outboundSchema)),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        hasPublicRightOfWay: "has_public_right_of_way",
        rightOfWayDetails: "right_of_way_details",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var RightOfWay$;
(function (RightOfWay$) {
    /** @deprecated use `RightOfWay$inboundSchema` instead. */
    RightOfWay$.inboundSchema = exports.RightOfWay$inboundSchema;
    /** @deprecated use `RightOfWay$outboundSchema` instead. */
    RightOfWay$.outboundSchema = exports.RightOfWay$outboundSchema;
})(RightOfWay$ || (exports.RightOfWay$ = RightOfWay$ = {}));
function rightOfWayToJSON(rightOfWay) {
    return JSON.stringify(exports.RightOfWay$outboundSchema.parse(rightOfWay));
}
function rightOfWayFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.RightOfWay$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'RightOfWay' from JSON`);
}
//# sourceMappingURL=rightofway.js.map